// extracted by mini-css-extract-plugin
export default {"container":"productCategory_container__rOMPc","box":"productCategory_box__VcDN+"};